import Masonry from "react-responsive-masonry";
import { useAppQuery } from "../../../http/useAppQuery.ts";
import { EmptyStateInformation } from "../../Board/Workspaces/components/EmptyStateInformation.tsx";
import { useWorkspaceUuid } from "../../hooks/useWorkspaceUuid.ts";
import { ViewLayout } from "../ViewLayout.tsx";
import { PurchasedContentTile } from "./PurchasedContentTile.tsx";
import type { UserPurchasedContents } from "./types.ts";

export const PurchasedView = () => {
  const workspaceUuid = useWorkspaceUuid();
  const { data: workspacePurchasedContents } =
    useAppQuery<UserPurchasedContents>({
      queryKey: `workspaces/${workspaceUuid}/purchased-contents`,
    });

  return (
    <ViewLayout title="Purchased images">
      <div id="AllPurchasedContents" className="flex-col">
        {workspacePurchasedContents &&
        workspacePurchasedContents.contents.length > 0 ? (
          <Masonry columnsCount={4} gutter="16px">
            {workspacePurchasedContents.contents.map((content) => (
              <PurchasedContentTile key={content.uuid} content={content} />
            ))}
          </Masonry>
        ) : (
          <EmptyStateInformation
            title="No images purchased yet!"
            body="Purchase images to see them here."
          />
        )}
      </div>
    </ViewLayout>
  );
};
